<template>
<div class="chapter">
<div class="inner_page">
<div class="bodyMatter">
<div class="part" id="pt01">
<div class="partHead" id="ph01">
<h2 class="partNumber"><a href="#/contents#pt_01"><span class="bold">ONE</span></a></h2>
<h2 class="partTitle"><a href="#/contents#pt_01"><span class="bold">In the Country</span></a></h2></div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// partone.vue?0afd89d0